<template>
  <div class="w-full px-6 py-4">
    <div class="mb-5 flex items-center">
      <o-icon icon="customerSegments" :size="20" class="mr-3 opacity-75" />
      <div>
        <p class="leading-none mb-1">
          {{ $t('general.segments') }}
        </p>
        <p class="leading-none text-sm opacity-60">
          {{ $t('components.customer.edit.segments.info') }}
        </p>
      </div>
    </div>

    <div>
      <div class="flex space-x-4 mb-4">
        <o-field-group class="w-full mb-4" :label="$t('general.segments')">
          <segement-select v-model="_customer.segments" />
        </o-field-group>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SegementSelect from '@/components/segment/elements/Select.vue'

interface Props {
  customer: Record<string, any>
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'update:customer', value: any): void
}>()

const _customer = computed({
  get () {
    return props.customer
  },
  set (value) {
    emit('update:customer', value)
  },
})
</script>
